<template>
    <div class="card-product-pages">
        <div class="bg-sky card-products-page pb-3 pb-lg-5">
            <v-header></v-header>
            <div class="container py-5">
                <div class="row">
                    <div class="col">
                        <h1 class="text-white text-center font-weight-bold text-uppercase"
                            v-text="getTranslation('cardProductsTitle')"></h1>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-md-6 col-lg-4 mx-auto py-5">
                    <form class="text-center">
                        <div class="row">
                            <div class="col">
                                <div class="form-group">
                                    <label for="wtp_number"><strong>Ingrese número de tarjeta: </strong></label>
                                    <input type="text" class="form-control" placeholder="A1B2C3D4-A1B-2C3" v-mask="'XXXXXXXX-XXX-XXX'" v-model="wtp_number" />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <button id="submit-card" class="btn btn-primary btn-lg btn-block" type="submit" :disabled="!wtp_number" @click="getCardProducts($event)">Consultar tarjeta</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="row text-center">
                <div class="col-md-6 col-lg-4 mx-auto pb-5">
                    <img style="max-height: 100px; width: auto;" src="~__STATIC__/loading.svg" v-if="is_loading"/>
                    <div class="text-left" v-if="successful_response && !is_loading">
                        <table class="w-100">
                            <tr>
                                <td><strong>Ticket</strong></td>
                                <td>{{ ticket_name }}</td>
                            </tr>
                            <tr>
                                <td><strong>Tipo persona</strong></td>
                                <td>{{ person_type }}</td>
                            </tr>
                            <tr>
                                <td><strong>Válido desde</strong></td>
                                <td>{{ valid_from }}</td>
                            </tr>
                            <tr>
                                <td><strong>Válido hasta</strong></td>
                                <td>{{ valid_to }}</td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div class="col text-left pb-5" v-if="on_error && !is_loading">
                    <p>Ha ingresado un número de tarjeta inválido :(</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import siteConfig from '../../mixins/siteConfig';
    import Datepicker from 'vuejs-datepicker';
    import API from '../../api/index';

    export default {

        mixins: [siteConfig],
        data() {
            return{
                wtp_number: '',
                ticket_name: null,
                person_type: null,
                valid_from: null,
                valid_to: null,
                successful_response: false,
                is_loading: false,
                on_error: false,
            }
        },
        components: {
            Datepicker
        },
        methods: {
            getCardProducts(e) {
                e.preventDefault();
                this.is_loading = true;
                this.on_error = false;
                API.card_products.post({
                    wtp_number: this.wtp_number.toUpperCase()
                }).then((response) => {
                    if (response.NERRORNO === "0") {
                        this.successful_response = true;
                        this.ticket_name = response.SZTICKETTYPENAME;
                        this.person_type = response.SZPERSONTYPENAME;
                        this.valid_from = response.SZVALIDFROM;
                        this.valid_to = response.SZVALIDTO;
                    } else {
                        this.successful_response = false;
                        this.on_error = true;
                    }

                }).catch((err) => {
                    this.on_error = true;
                    this.successful_response = false;
                    this.ticket_name = null;
                    this.person_type = null;
                    this.valid_from = null;
                    this.valid_to = null;
                }).finally(() => {
                    this.is_loading = false;
                });
            }
        },
        watch: {},
        computed: {}
    }
</script>



// WEBPACK FOOTER //
// src/components/Pages/CardProductsPage.vue